import { useEffect, useState } from "react";
import AppPageHeader from "../../../components/Headers/AppPageHeader";
import AppHelmet from "../../../components/AppComponents/AppHelmet";
import { Container } from "reactstrap";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { AppToggle } from "../../../components/Drawers/Fields/CustomToggle";
import useClouds from "../../../api/api-hooks/cloud/useClouds";
import useCloud from "../../../api/api-hooks/cloud/useCloud";
import useUpdateClouds from "../../../api/api-hooks/cloud/useUpdateClouds";
import { AppConfirm } from "../../../utils/PopupUtil";

const tabs = [
  {
    title: "System Health",
    activeValue: "system-health",
    disabled: true,
  },
  {
    title: "Maintenance Mode",
    activeValue: "maintenance-mode",
    disabled: false,
  },
  {
    title: "Activity Log",
    activeValue: "activity-log",
    disabled: true,
  },
];

const HealthMaintenance = () => {
  const { clouds, cloudsLoading } = useClouds();
  const { cloud } = useCloud(clouds ? clouds[0].TenantID : "");
  const { updateClouds, updatingClouds } = useUpdateClouds();
  const [activeTab, setActiveTab] = useState("maintenance-mode");
  const [maintenance, setMaintenance] = useState<any>({
    Status: false,
    Title: "",
    Description: "",
    EndDateTime: "",
  });

  useEffect(() => {
    if (!cloud) {
      return setMaintenance({
        Status: false,
        Title: "",
        Description: "",
        EndDateTime: "",
      });
    }

    setMaintenance(cloud?.Maintenance);
  }, [cloud]);

  const handleChangeMaintenanceMode = async (field: string, val: any) => {
    if (val === true) {
      const result = await AppConfirm({
        title: "Confirm Maintenance Mode",
        text: "Are you sure you want to enable maintenance mode? All non supportal users won't be able to access GrowthCloud.",
        confirmButtonText: "Confirm",
      });

      if (!result.isConfirmed) return;
    }

    const maintenanceCopy = { ...maintenance, [field]: val };
    setMaintenance(maintenanceCopy);

    await updateClouds({ payload: { Maintenance: maintenanceCopy } });
  };

  return (
    <>
      <AppHelmet title="Clouds - GrowthCloud.com" />
      <div className="header pb-6">
        <Container fluid>
          <AppPageHeader
            title="Maintenance"
            description="Manage maintenance action on your GrowthCloud Instance"
          />
          <AppNavbar
            tabs={tabs}
            activeTab={activeTab}
            onSelect={(val: string) => setActiveTab(val)}
          />
          <div
            className="d-flex flex-column p-4 mt-4 rounded w-100 border bg-ultralight"
            style={{
              maxWidth: 600,
            }}
          >
            <span className="font-weight-bold">Enable Maintenance Mode</span>
            <p className="mt-2">
              Enable or disable maintenance mode. When enabled, the platform
              will be temporarily inaccessible to users. For super admins it
              will show a banner at the top of the application indicating the
              maintenance mode.
            </p>
            <AppToggle
              value={maintenance?.Status ?? false}
              handleChange={(e) =>
                handleChangeMaintenanceMode("Status", e.target.checked)
              }
            />
          </div>
        </Container>
      </div>
    </>
  );
};

export default HealthMaintenance;
